export const FETCH_XML_FEEDS_START = 'FETCH_XML_FEEDS_START';
export const FETCH_XML_FEEDS_SUCCESS = 'FETCH_XML_FEEDS_SUCCESS';
export const FETCH_XML_FEEDS_FAILURE = 'FETCH_XML_FEEDS_FAILURE';

export const FETCH_PUSH_FEEDS_START = 'FETCH_PUSH_FEEDS_START';
export const FETCH_PUSH_FEEDS_SUCCESS = 'FETCH_PUSH_FEEDS_SUCCESS';
export const FETCH_PUSH_FEEDS_FAILURE = 'FETCH_PUSH_FEEDS_FAILURE';

export const SET_FEED_DESC_START = 'SET_FEED_DESC_START';
export const SET_FEED_DESC_SUCCESS = 'SET_FEED_DESC_SUCCESS';
export const SET_FEED_DESC_FAILURE = 'SET_FEED_DESC_FAILURE';

export const SET_FEED_PAUSED_START = 'SET_FEED_PAUSED_START';
export const SET_FEED_PAUSED_SUCCESS = 'SET_FEED_PAUSED_SUCCESS';
export const SET_FEED_PAUSED_FAILURE = 'SET_FEED_PAUSED_FAILURE';

export const FETCH_FEED_INFO_START = 'FETCH_FEED_INFO_START';
export const FETCH_FEED_INFO_SUCCESS = 'FETCH_FEED_INFO_SUCCESS';
export const FETCH_FEED_INFO_FAILURE = 'FETCH_FEED_INFO_FAILURE';
